import React from 'react';
import {connect} from "react-redux";
import DateData from '../components/DateData';
import RequestButton from '../components/RequestButton';
import {gotDateUsers} from "../actions/data";
import {setClearResults} from '../actions/filters';
import {buttonStyles} from "./common/CommonButton";
import ClearButton from "./common/ClearButton";
import Pagination from "../components/Pagination";
import FilterInfoPanel from "../components/FilterInfoPanel";

const DateList=(props)=>{
    return(
        <div className='system-container'>
            <ClearButton panel='dateusers'/>
            <FilterInfoPanel />
            <Pagination type='dateusers' path='/date/users' handleData={gotDateUsers} lastPage={props.data.lastPage}/>
            {props.data.dateUsers && props.data.dateUsers.map((data, index)=>
            {return <DateData items={data} key={index}/>})}
        </div>)
};

const mapStateToProps=(state)=>({data:state.data, limit: state.filters.limit, curPage: state.filters.curPage, clearResults: state.filters.clearResults, filters: state.filters});
const ConnectedDateList=connect(mapStateToProps)(DateList);
export default ConnectedDateList;